import { ProfileMenu } from 'app-components/accounts/profiles/menu/ProfileMenu';
import { Link } from 'ui-components/common/Link';
import { DirittoIcon } from 'icons/DirittoIcon';
import { Menu, MenuContainer, MenuItem, MenuWrapper } from 'ui-components/navigations/menu/Menu';
import { useRouter } from 'next/navigation';
import { useCallback } from 'react';
import { useClient } from 'ui-hooks/useClient';
import { DirittoAppBridge } from 'libs/DirittoAppBridge';
import { ExternalLink } from 'ui-components/common/ExternalLink';
import { CONTENT_HELP_URL, DIRITTO_STUDIO_SURVEY } from '@diritto/common/constants/url';
import { useTrackingState } from 'contexts/TrackingProvider';
import {
  ClickAction,
  ClickTargetType,
  TrackerExtraInfo,
  TrackerPosition,
  TrackingEventType,
} from '@diritto/common/tracker/tracking-event.constant';
import { useAuthState } from 'contexts/AuthProvider';

type MenuProps = {
  onBlur?: () => void;
};

const trackerExtraInfo: TrackerExtraInfo = {
  trackerPosition: TrackerPosition.DirittoStudioMenu,
};

export const DirittoStudioMenu = ({ onBlur }: MenuProps) => {
  const router = useRouter();
  const client = useClient();
  const { tracker } = useTrackingState();
  const { profile } = useAuthState();

  const handleTrack = useCallback(
    (action: ClickAction, clickType: ClickTargetType) => {
      tracker.track(TrackingEventType.Click, { action, clickType, trackerExtraInfo });
    },
    [tracker],
  );

  const handleGoToDiritto = useCallback(() => {
    handleTrack(ClickAction.ToDiritto, ClickTargetType.Menu);

    if (client.isApp) {
      DirittoAppBridge.resetToHome();
    }
  }, [client.isApp, handleTrack]);

  return (
    <MenuContainer>
      <ProfileMenu showInboxUnread={false} onBlur={onBlur} onProfileChanged={() => router.replace('/studio')} />
      <MenuWrapper onClick={onBlur}>
        <Menu>
          <ExternalLink
            href={`${DIRITTO_STUDIO_SURVEY}#profile_id=${profile?.id}`}
            onClick={() => handleTrack(ClickAction.ToDirittoStudioSurvey, ClickTargetType.Menu)}>
            <MenuItem>디리토 스튜디오 의견 주기</MenuItem>
          </ExternalLink>
        </Menu>
        <Menu>
          <ExternalLink
            href={CONTENT_HELP_URL.DIRITTO_STUDIO}
            onClick={() => handleTrack(ClickAction.ToDirittoStudioManual, ClickTargetType.Menu)}>
            <MenuItem>디리토 스튜디오 사용법</MenuItem>
          </ExternalLink>
        </Menu>
        <Menu>
          <Link href="/" onClick={handleGoToDiritto} replace>
            <MenuItem>
              디리토로 가기
              <DirittoIcon className="size-[16px]" />
            </MenuItem>
          </Link>
        </Menu>
      </MenuWrapper>
    </MenuContainer>
  );
};
